import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 42,
	viewBox: "0 0 41 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 1,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#6674CC"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_4791_269818)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M23.8333 24.3332L20.5 20.9999M20.5 20.9999L17.1666 24.3332M20.5 20.9999V28.4999M27.4916 26.3249C28.3044 25.8818 28.9465 25.1806 29.3165 24.3321C29.6866 23.4835 29.7635 22.5359 29.5351 21.6388C29.3068 20.7417 28.7862 19.9462 28.0555 19.3778C27.3248 18.8094 26.4257 18.5005 25.5 18.4999H24.45C24.1977 17.5243 23.7276 16.6185 23.0749 15.8507C22.4222 15.0829 21.604 14.4731 20.6817 14.0671C19.7594 13.661 18.7571 13.4694 17.7501 13.5065C16.743 13.5436 15.7575 13.8085 14.8676 14.2813C13.9777 14.7541 13.2066 15.4225 12.6122 16.2362C12.0177 17.05 11.6155 17.9879 11.4358 18.9794C11.256 19.9709 11.3034 20.9903 11.5743 21.961C11.8452 22.9316 12.3327 23.8281 13 24.5832",
				stroke: "#CED1E3",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 1,
			width: 40,
			height: 40,
			rx: 20,
			stroke: "#9FA8DF"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4791_269818",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(10.5 11)"
			})
		}) })
	]
});
export default SvgUploadFile;
